import { userDBApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initDBExport({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchSummary'), dispatch('fetchUsers')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   */
  async fetchSummary({ commit }) {
    try {
      const response = await userDBApi.requestSummary();
      commit('setSummary', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   */
  async fetchUsers({ commit }) {
    try {
      const response = await userDBApi.requestList();
      commit('addUsers', response.data.users);
      commit('setPaging', response.data.paging);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async incrementUsers({ commit, dispatch }) {
    commit('setAdding', true);
    await dispatch('fetchUsers');
    commit('setAdding', false);
  },
};
